import { createQueryKeys } from '@codes/base-api';

export const cardQueryKeys = createQueryKeys('cards');
